import { aboutUsHistory } from "../../assets/images";

export const AboutUsHeroData = {
  title: "We believe the power of software can unlock every human’s potential",
  stats: [
    { label: "funding raised", value: "$450m+" },
    { label: "employees (42 nationalities)", value: "900+" },
    { label: "saved by cloud customers", value: "$20m+" },
    { label: "5 star Trustpilot reviews", value: "74%" },
  ],
  buttonText: "Who we are",
  buttonLink: "#",
};

export const AboutHistoryData = {
  title: "Why are we here?",

  paragraph:
    "Our founder started one of the world’s first cloud computing companies with his best friend. But after being let down by developers they realised, if 2 engineers, based in a San Fran tech hub had failed – how could most people even begin to build an app?",

  secondaryParagraph:
    "Together Sachin, and Saurabh who left the company in 2022, had the idea to make building apps as easy as ordering pizza. Here’s the full story…",

  image: aboutUsHistory,
};
